import styled from "styled-components";

export const StyledIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: fit-content;
`;
